import Kr from 'Kr/kr';

import 'KrComponent/CreateShopForm.js';
import 'KrComponent/CheckShopStatus.js';

const app = new Kr.App;
app.run();
